import { ISharedItemNote } from "@/Common/Api/PortalCommunication/ISharedItemNote";
import { NameHelper, NameHelperFormat } from "@/Common/Helpers/NameHelper";
import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";

class SharedItemNote {
    public noteId: string;
    public note: string;
    public employeeId: string;
    public dateCreated: Date;

    constructor(init?: Partial<SharedItemNote>) {
        Object.assign(this, init);
    }

    public static fromResponseModel(response: ISharedItemNote): SharedItemNote {
        if (!response) {
            return null;
        }

        return new SharedItemNote({
            noteId: response.NoteId,
            note: response.Note,
            employeeId: response.EmployeeId,
            dateCreated: response.DateCreated ? new Date(response.DateCreated) : null
        });
    }

    public get employeeName(): string {
        const employee = cacheStore.GetEmployeeByContactFacetId(this.employeeId);

        if (!employee) {
            return "";
        }

        return NameHelper.formatFullNameWithPrefixForHasName({
            FirstName: employee.FirstName,
            LastName: employee.LastName,
            PrefixLookupId: employee.PrefixLookupId
        }, NameHelperFormat.FirstNameFirst);
    }

    public get dateLabel(): string {
        return LuxonDateTimeParser.parse(this.dateCreated)?.toFormat(`yyyy/MM/dd '${cacheStore.GetString("AtLabel")}' HH:mm`);
    }
}

export { SharedItemNote };
